var map = {
	"./heirs/complete": 5,
	"./heirs/complete.js": 5,
	"./heirs/invitation": 6,
	"./heirs/invitation.js": 6,
	"./inquiries/complete": 7,
	"./inquiries/complete.js": 7,
	"./inquiries/new": 8,
	"./inquiries/new.js": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;